<div class="h-100 d-flex flex-column flex-nowrap justify-content-between">
  <div class="configurator">
      <div class="configurator-body">
          <div class="top-section justify-content-center">
              <div class="commands commands-left">
                  <button
                      mat-flat-button
                      class="bticino-ico arrow-up round-button-with-background blu-border"
                      (click)="onPlateUp()"
                    >
                  </button>
                  <div class="text font-bticino-bold p-y-16 text-center">
                    {{ 'b2c.IDS_CHANGEPLATE' | translate }}
                  </div>
                  <button
                      mat-flat-button
                      class="bticino-ico arrow-down round-button-with-background blu-border"
                      (click)="onPlateDown()"
                    >
                  </button>
              </div>
              <div class="result" [ngClass]="{'livinglight': ds.getFinishingID() == 3}">
                  <div class="black-background" *ngIf="ds.getFinishingID() != 4"></div>
                  <img class="plate-img" [src]="plateUrl" width="100%" *ngIf="plateUrl">
                  <div class="buttons" *ngIf="switchesUrl">
                      <img [src]="switchesUrl">
                  </div>
              </div>
              <div class="commands commands-right" *ngIf="ds.getFinishingID() != 2">
                  <button
                      mat-flat-button
                      class="bticino-ico arrow-up round-button-with-background blu-border"
                      (click)="onSwitchUp()"
                    >
                  </button>
                  <div class="text font-bticino-bold p-y-16 text-center">
                      {{ (ds.getFinishingID() == 4 ? 'b2c.IDS_CHANGECOVER' : 'b2c.IDS_CHANGEBUTTON') | translate }}
                  </div>
                  <button
                    mat-flat-button
                    class="bticino-ico arrow-down round-button-with-background blu-border"
                    (click)="onSwitchDown()"
                  >
                  </button>
              </div>
          </div>
      </div>
  </div>


  <div class="result-summary p-y primary-background font-weight-light d-flex flex-row flex-nowrap justify-content-center">
    <div class="center-div m-w-400 w-100">
      <div class="choices">
          <p>{{ 'b2c.IDS_PLATE' | translate }}: <b *ngIf="selectedPlate">{{ selectedPlate.Color | translate }}</b></p>
          <p>{{ (ds.getFinishingID() == 4 ? 'b2c.IDS_COVER' : 'b2c.IDS_BUTTON') | translate }}: <b *ngIf="selectedSwitch">{{ selectedSwitch.name | translate }}</b></p>
      </div>
      <hr/>
      <p class="price-valuation">{{ 'b2c.IDS_COMBINATIONCOST' | translate }} <b *ngIf="selectedPlate">{{ selectedPlate.ItemPrice | currency:'EUR':'symbol':'1.2-2':'it' }}</b></p>
    </div>
  </div>

</div>
